import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { doc, getDoc } from 'firebase/firestore';
import { db } from '../../firebase';
import { getAuth } from 'firebase/auth';
import '../../css/DetailPage.css';
import { useNavigate } from 'react-router-dom';

function DetailPage() {
    const { id } = useParams();
    const [product, setProduct] = useState(null);
    const [selectedImage, setSelectedImage] = useState(null);
    const [quantity, setQuantity] = useState(1); // ✅ quantity state
    const navigate = useNavigate();
    const auth = getAuth();

    const [showPopup, setShowPopup] = useState(false);
    const [customerName, setCustomerName] = useState("");
    const [phone, setPhone] = useState("");
    const [address, setAddress] = useState("");

    // ✅ Fetch product
    useEffect(() => {
        const fetchProduct = async () => {
            const productRef = doc(db, "products", id);
            const docSnap = await getDoc(productRef);
            if (docSnap.exists()) {
                const data = { id: docSnap.id, ...docSnap.data() };
                setProduct(data);
                setSelectedImage(data.image);
            } else {
                console.error("No such product!");
            }
        };
        fetchProduct();
    }, [id]);

    const increaseQty = () => setQuantity(prev => prev + 1);
    const decreaseQty = () => setQuantity(prev => (prev > 1 ? prev - 1 : 1));

    if (!product) {
        return <div>Loading...</div>;
    }

    const handleAddToCart = () => {

        const user = auth.currentUser;

        if (!user) {
            alert("You must be logged in to add items to cart.");
            navigate("/login"); // 👈 redirect to login page
            return;
        }

        const cartItem = {
            id: product.id,
            title: product.title,
            price: product.price,
            image: product.image,
            quantity: quantity,
            sku: product.sku,
        };

        let existingCart = JSON.parse(localStorage.getItem('cart')) || [];

        const existingIndex = existingCart.findIndex(item => item.id === cartItem.id);

        if (existingIndex !== -1) {
            // If item already exists in cart, just update quantity
            existingCart[existingIndex].quantity += quantity;
        } else {
            // Add new item
            existingCart.push(cartItem);
        }

        localStorage.setItem('cart', JSON.stringify(existingCart));
        alert('Product added to cart!');
    };

    const handleWhatsAppOrder = () => {
        setShowPopup(true); // open popup
    };

    // ✅ Handle WhatsApp order (no useEffect, fetch inside here)
    const submitOrder = () => {

        if (!customerName || !phone || !address) {
            alert("Please fill all fields");
            return;
        }

        const whatsappMessage = `
            Hello, I would like to place an order:

            🛍 Product: ${product.title}
            💰 Price: Rs.${product.price?.toLocaleString('en-LK')}
            🔢 Quantity: ${quantity}
            📦 SKU: ${product.sku}

            📌 Total: Rs.${(product.price * quantity).toLocaleString('en-LK')}

            👤 Customer Name: ${customerName}
            📞 Phone: ${phone}
            🏠 Address: ${address}

            Please confirm my order. ✅
        `;

        // ✅ Open WhatsApp with message
        window.open(`https://wa.me/94773719375?text=${encodeURIComponent(whatsappMessage)}`, "_blank");

        setShowPopup(false);
    };

    return (
        <div className="detail-page">
            <div className="product-container">
                <div className="product-images">
                    {product.video ? (
                        <video
                            src={product.video}
                            controls
                            autoPlay
                            loop
                            muted
                            className="main-video"
                        />
                    ) : (
                        <img src={selectedImage} alt={product.title} className="main-image" />
                    )}

                    <div className="thumbnail-row">
                        {[product.image, ...(product.otherImages || [])].map((img, i) => (
                            <img
                                key={i}
                                src={img}
                                alt={`thumb-${i}`}
                                onClick={() => setSelectedImage(img)}
                                className={selectedImage === img ? 'thumbnail active' : 'thumbnail'}
                            />
                        ))}
                    </div>
                </div>

                <div className="product-info-details">
                    <h1>{product.title}</h1>
                    <div className="price-container">
                        {product.discount && product.discount > 0 ? (
                            <>
                                <span className="discounted-price">
                                    Rs.{(product.price - (product.price * product.discount / 100)).toLocaleString('en-LK')}
                                </span>
                                <span className="discount-percentage">
                                    {product.discount}% off
                                </span>
                                <span className="original-price">
                                    Rs.{product.price?.toLocaleString('en-LK')}
                                </span>
                            </>
                        ) : (
                            <span className="discounted-price">
                                Rs.{product.price?.toLocaleString('en-LK')}
                            </span>
                        )}
                    </div>
                    <p><strong>SKU:</strong> {product.sku}</p>
                    <p><strong>Stock:</strong> {product.inStock ? `${product.stockQty} in stock` : 'Out of stock'}</p>
                    <p><strong>Category:</strong> {product.category}</p>

                    {/* Quantity + Buttons */}
                    <div className="purchase-row">
                        <div className="qty-counter">
                            <button onClick={decreaseQty}>−</button>
                            <input type="text" value={quantity} readOnly />
                            <button onClick={increaseQty}>+</button>
                        </div>

                        <div className="order-actions">
                            <button className="btn-whatsapp" onClick={handleWhatsAppOrder}>
                                Order on WhatsApp
                            </button>
                            <span className="shipping-info">
                                {product.shippingCost && product.shippingCost > 0
                                    ? `Shipping: Rs.${product.shippingCost.toLocaleString('en-LK')}`
                                    : 'Free Shipping'}
                            </span>
                        </div>

                        {/* Add to Cart button */}
                        {/* <button className="btn-cart" onClick={handleAddToCart}>
                            Add to Cart
                        </button> */}

                    </div>


                    <br />
                    <p>{product.description}</p>
                </div>
                {showPopup && (
                    <div className="popup-overlay">
                        <div className="popup-box">
                            <h2>Enter Delivery Details</h2>

                            <input
                                type="text"
                                placeholder="Customer Name"
                                value={customerName}
                                onChange={(e) => setCustomerName(e.target.value)}
                            />

                            <input
                                type="text"
                                placeholder="Phone Number"
                                value={phone}
                                onChange={(e) => setPhone(e.target.value)}
                            />

                            <textarea
                                placeholder="Address"
                                value={address}
                                onChange={(e) => setAddress(e.target.value)}
                            />

                            <div className="popup-buttons">
                                <button className="btn-submit" onClick={submitOrder}>
                                    Send Order
                                </button>

                                <button className="btn-cancel" onClick={() => setShowPopup(false)}>
                                    Cancel
                                </button>
                            </div>
                        </div>
                    </div>
                )}
            </div>
        </div >
    );
}

export default DetailPage;
